import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const CARDS = [
  {
    icon: Phone,
    testId: "contact-phone-card",
    label: "Call or text",
    value: "404-703-2343",
    href: "tel:+14047032343",
  },
  {
    icon: Mail,
    testId: "contact-email-card",
    label: "Email Renee",
    value: "sales@huntshieldinsurance.com",
    href: "mailto:sales@huntshieldinsurance.com",
  },
  {
    icon: MapPin,
    testId: "contact-location-card",
    label: "Based in",
    value: "Atlanta, Georgia",
    sub: "Serving the greater metro area",
  },
  {
    icon: Clock,
    testId: "contact-hours-card",
    label: "Office hours",
    value: "Mon–Fri · 9am–6pm",
    sub: "Evenings & Saturdays by appointment",
  },
];

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="relative py-24 sm:py-32 lg:py-36">
    <div className="pointer-events-none absolute bottom-0 right-[-8%] h-[26rem] w-[26rem] rounded-full bg-amber-500/[0.06] blur-[120px]" />
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
      <Reveal>
        <Eyebrow testId="contact-eyebrow">Get in touch</Eyebrow>
        <h2
          data-testid="contact-heading"
          className="max-w-3xl font-serif text-2xl tracking-tight text-[color:var(--ns-ink)] sm:text-3xl lg:text-4xl"
        >
          One conversation can <em className="text-[color:var(--ns-gold)]">change how covered you feel.</em>
        </h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {CARDS.map((c, i) => {
          const Icon = c.icon;
          const inner = (
            <>
              <span className="mb-5 inline-flex h-11 w-11 items-center justify-center rounded-xl border border-[color:var(--ns-gold)]/25 bg-[color:var(--ns-gold)]/10 text-[color:var(--ns-gold)]">
                <Icon size={19} />
              </span>
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[color:var(--ns-muted)]">{c.label}</p>
              <p className="mt-2 break-words font-medium text-[color:var(--ns-ink)]">{c.value}</p>
              {c.sub && <p className="mt-1 text-xs text-[color:var(--ns-muted)]">{c.sub}</p>}
            </>
          );
          return (
            <Reveal key={c.testId} delay={0.08 * i}>
              {c.href ? (
                <a href={c.href} data-testid={c.testId} className="spotlight-card block h-full rounded-3xl p-7">
                  {inner}
                </a>
              ) : (
                <div data-testid={c.testId} className="spotlight-card h-full rounded-3xl p-7">
                  {inner}
                </div>
              )}
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
